import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Enumerable } from 'linq-typescript';
interface Statuscolors {
  Priority: string;
  Color: string;
  Value: number;
  WidthVal: number;
  Text?: string
}

interface ColorCodes {
  red: string;
  blue: string;
  green: string;
  orange: string;

}
@Component({
  selector: 'app-status-colors',
  templateUrl: './status-colors.component.html',
  styleUrls: ['./status-colors.component.css']
})

export class StatusColorsComponent implements OnChanges {
  @Input() StatusColor: any;
  StatusColorInternal: Statuscolors[] = [];
  constructor() { }
  // ngOnChanges(changes: SimpleChanges): void {
  //   throw new Error('Method not implemented.');
  // }

  ngOnChanges() {

    this.StatusColorInternal = [];
    this.StatusColorInternal = JSON.parse(this.StatusColor);
    let arr = this.StatusColorInternal.map(item => item.Value)

    this.StatusColorInternal.forEach(x => {
      if (x.Color == 'Red') {
        x.Color = '#f44336';
        x.Text = 'Failed';

      } else if (x.Color == 'Green') {
        x.Color = '#33ad38';
        x.Text = 'Met';
      }
      else if (x.Color == 'Blue') {
        x.Color = '#9d9d9d'
      }
      else if (x.Color == 'Orange') {
        x.Color = '#f19e0d';
        x.Text = 'Exception';
      }
      else if (x.Color == 'Gray') {
        x.Color = 'gray';
        x.Text = 'Not Met';
      }
    })

    let totalval = arr.reduce(function (a, b) {
      return a + b;
    });

    this.StatusColorInternal.filter(item => {

      let widthval = (item.Value * 100) / totalval
      item.WidthVal = widthval;
    });


  }
  getColor(priority, ele) {
    return { 'background-color': ele.Color + '', 'width': ele.WidthVal + '%', 'display': ele.WidthVal == 0 ? 'none' : 'block' }
  }



}